module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_03_american-village-92c76f8d2f9125e2a4a0591a38ae6530.jpg";